import Tile from './Tile';
import TileDivision from './TileDivision';

export default Tile;

export { TileDivision };
